import type {ImageField} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import {PrismicNextImage} from '@prismicio/next/pages'
import cn from 'classnames'

type ResponsiveImageProps = {
  image: ImageField & {Mobile?: ImageField}
  desktopClassName?: string
  mobileClassName?: string
  pictureClassName?: string
  quality?: number
}

export const ResponsiveImage = ({
  image,
  desktopClassName,
  mobileClassName,
  pictureClassName,
  quality = 100,
}: ResponsiveImageProps) => {
  if (!isFilled.image(image)) {
    return null
  }

  const hasMobileImage = isFilled.imageThumbnail(image.Mobile)

  return (
    <picture className={pictureClassName}>
      {hasMobileImage && (
        <PrismicNextImage field={image.Mobile} className={cn('w-full', mobileClassName)} quality={quality} />
      )}
      <PrismicNextImage
        field={image}
        className={cn('size-full', desktopClassName, {
          'max-lg:hidden': hasMobileImage,
        })}
        quality={quality}
      />
    </picture>
  )
}
